import React, { FC, HTMLAttributes, memo } from "react";
import styled from "styled-components";

export type Props = HTMLAttributes<HTMLDivElement>;
const KaleidoShoppingText: FC<Props> = (...props) => {
  return(
    <Root {...props}>
      <Text>
        このプロジェクトは『カレイドスター20周年音楽祭』の事前通販ページになります。<br />
        音楽祭当日にも同一商品を販売いたします。<br />
        <br />
        ＜なぜ事前通販を行うのか？＞<br />
        音楽祭当日に、時間がかかりすぎて購入を断念される方や、在庫切れで買えない方などを少しでも無くしたいという意図で事前通販をさせていただきます。<br />
        <br />
        <Note>注意：プロジェクトはふるさと納税ではございません。税金の控除等はございません。</Note>
      </Text>
    </Root>
  )
};
export default memo(KaleidoShoppingText);

const Root = styled.div`
  border: 1px solid #fff;
  padding: 10px;
  color: white;
  line-height: 1.428em;
  @media screen and (max-width: 1280px) {
    font-size: 14px;
  }
  @media screen and (min-width: 1281px) {
    font-size: 16px;
  }
`;
const Text = styled.div`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const Note = styled.div`
  @media screen and (max-width: 1280px) {
    font-size: 13px;
  }
  @media screen and (min-width: 1281px) {
    font-size: 14px;
  }
`;